export const emailPrefixCutter = (email: string): string | null => {
  const idx = email.indexOf('@');
  return idx > 0 ? email.slice(0, idx) : null;
};
